import { ITableData } from '../../pricing-simulator/types/generic-table.model';
import { axios } from 'src/lib';
import { IResponseBase } from 'src/types/response-base';
import { GET_CLUSTER_SUMMARY_DATA } from 'src/constants';

export function getClusterSummaryTableData(
  sourceId: number
) {
  return axios
    .get(`${GET_CLUSTER_SUMMARY_DATA}${sourceId}/`)
    .then<ITableData>((response) => response.data);
}